import { render, staticRenderFns } from "./MaintenanceByGameBody.vue?vue&type=template&id=060bddee&scoped=true&"
import script from "./MaintenanceByGameBody.vue?vue&type=script&lang=ts&"
export * from "./MaintenanceByGameBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060bddee",
  null
  
)

export default component.exports